import { render, staticRenderFns } from "./FeaturedAddDesign.vue?vue&type=template&id=6c81e44a&"
import script from "./FeaturedAddDesign.vue?vue&type=script&lang=js&"
export * from "./FeaturedAddDesign.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAddDesign.vue?vue&type=style&index=0&id=6c81e44a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports